import { authApi } from './client';

const ACCEPT_JSON = { 'Accept': 'application/json' };
const JSON_HEADERS = { 'Content-Type': 'application/json' };

export const listUsers = () =>
    authApi.get('/listar-profesores/', { headers: ACCEPT_JSON });

export const createUser = ({ nombre, email, password, isStaff, estado }) =>
    authApi.post('/crear-profesor/', JSON.stringify({ nombre, email, password, isStaff, estado }), { headers: JSON_HEADERS });

export const updateUser = ({ id, nombre, email, isStaff, estado, password }) =>
    authApi.put('/actualizar-profesor/', JSON.stringify({ id, nombre, email, isStaff, estado, password }), { headers: JSON_HEADERS });

export const deleteUser = id =>
    authApi.delete('/eliminar-profesor/', { headers: ACCEPT_JSON, data: { id } });
